import BacnetObjects from '../../../base/menu/airdome/BacnetObjects';

const bacnetObjects: BacnetObjects = {
  categoryName: 'Bacnet objekty',
  view: 'Zobrazit',
  edit: 'Upravit'
};

export default bacnetObjects;
